import React from "react";
import { Box, Button, Typography, Stack } from "@mui/material";

// PLAN-004 Phase 3.5: Error boundary to catch render crashes
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console in development — replace with error reporting service in production
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          bgcolor="#f5f5f5"
        >
          <Stack alignItems="center" spacing={2} p={4}>
            <Box
              component="img"
              src="/recursos/PNG/MiSalud BRANDMARK full colour w-TM.png"
              alt="MiSalud"
              width={80}
              height={80}
              sx={{ objectFit: "contain" }}
            />
            <Typography variant="h5" color="text.primary">
              Algo salió mal
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Ha ocurrido un error inesperado. Por favor, intenta de nuevo.
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                onClick={this.handleReset}
                sx={{ backgroundColor: "#075C87", borderRadius: 6 }}
              >
                Intentar de nuevo
              </Button>
              <Button
                variant="outlined"
                onClick={() => (window.location.href = "/")}
                sx={{ borderColor: "#075C87", color: "#075C87", borderRadius: 6 }}
              >
                Ir al inicio
              </Button>
            </Stack>
          </Stack>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
